exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_groups_f_wdRc6C6lZXRX6bU_7ye {\n  width: 100%;\n  margin-top: 20px;\n}", ""]);

// Exports
exports.locals = {
	"IA_groups": "IA_groups_f_wdRc6C6lZXRX6bU_7ye"
};